export default __webpack_public_path__ + "static/interkabv-5b533edee13e9fbd7bbfeb740750605f.png";